module.exports = __webpack_public_path__ + "static/media/HUN.68023c81.jpg";